import clsx from 'clsx'
import React, { FC } from 'react'

import LeftArrow from '@Components/Product/Slider/Components/Arrow/LeftArrow'
import RightArrow from '@Components/Product/Slider/Components/Arrow/RightArrow'

import styles from './ArrowPagination.module.scss'

interface ArrowProps {
  className?: string
  disable?: {
    left: boolean
    right: boolean
  }
  mobileArrows?: boolean
  noBackground?: boolean
}

interface Props extends ArrowProps {
  onClickLeft: (event) => void
  onClickRight: (event) => void
}

const ArrowPagination: FC<Props> = ({ className, disable = { left: false, right: false }, mobileArrows = false, noBackground, onClickLeft, onClickRight }) => {
  const handleRightClick = (event) => {
    event.stopPropagation()
    onClickRight(event)
  }
  const handleLeftClick = (event) => {
    event.stopPropagation()
    onClickLeft(event)
  }
  return (
    <>
      <LeftArrow
        className={clsx(
          className,
          styles.arrowPagination,
          styles.left,
          disable.left && styles.disabled,
          noBackground && styles.noBackground,
          mobileArrows && styles.mobileArrows,
        )}
        onClick={disable.left ? undefined : handleLeftClick}
      />
      <RightArrow
        className={clsx(
          className,
          styles.arrowPagination,
          styles.right,
          disable.right && styles.disabled,
          noBackground && styles.noBackground,
          mobileArrows && styles.mobileArrows,
        )}
        onClick={disable.right ? undefined : handleRightClick}
      />
    </>
  )
}

export default ArrowPagination
